import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../../text';
import { Col, Row } from '../../layout';

const StyledInput = styled.input`
  padding: 10px;
  transform: scale(1.5);
`;
const StyledCol = styled(Col)`
  margin-top: -3px;
  padding-left: 2px;
`;

export default class CheckBox extends PureComponent {
  static defaultProps = {
    value: '',
    checked: false,
  };

  static propTypes = {
    checked: PropTypes.bool,
    value: PropTypes.string,
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  onChange = () => {
    const { onChange, id, value } = this.props;

    onChange(id, value);
  };

  render() {
    const { value, checked } = this.props;

    return (
      <label>
        <Row>
          <Col>
            <StyledInput
              type="checkbox"
              value={value}
              checked={checked}
              onChange={this.onChange}
            />
          </Col>
          <StyledCol>
            <Text>{value}</Text>
          </StyledCol>
        </Row>
      </label>
    );
  }
}
